import type { PDPClickEventProps } from '@/scopes/products/infrastructure/analytics';
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics';

interface CreateDataLayerEventProps {
  element: string;
  isOpen: boolean;
}

export function createDataLayerEvent({ element, isOpen }: CreateDataLayerEventProps) {
  const event: PDPClickEventProps = {
    element: 'Accordion',
    description: `Practical information ${element} item accordion is ${isOpen ? 'opened' : 'closed'}`,
    result: `Practical information - ${element} ${isOpen ? 'opened' : 'closed'}`,
  };
  return createPDPClickEvent(event);
}
